import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { IGlossaryEntry } from '~/types/glossary'

import ActionMenu from '~/components/ActionMenu'

import './styles.scss'

interface Props {
  entry: IGlossaryEntry
  onCopy?: VoidFunction
  onDelete?: VoidFunction
  onEdit?: VoidFunction
}

const EntryBlock = ({ entry, onCopy, onDelete, onEdit }: Props): ReactElement => {
  /** Local state */

  const { long_description, short_description, title } = entry

  const menu: Menu = {
    actions: [
      ...(onCopy
        ? [
            {
              action: () => onCopy(),
              label: 'Copy the url for sharing',
            },
          ]
        : []),
      ...(onEdit
        ? [
            {
              action: () => onEdit(),
              label: 'Edit',
            },
          ]
        : []),
      ...(onDelete
        ? [
            {
              action: () => onDelete(),
              label: 'Delete',
            },
          ]
        : []),
    ],
  }

  /** Render */

  return (
    <div className="entry-block">
      <div className="header">
        <span className="title">{title}</span>
        <ActionMenu menu={menu} menuClassName="action-menu" />
      </div>
      <div className="content">
        <div className="short-description">{short_description}</div>
        <div className="long-description">{long_description}</div>
      </div>
    </div>
  )
}

export default EntryBlock
